/*
 * Product gallery — thumbnail navigation for the PDP media slideshow.
 *
 * The main slider (.bd-slider) is initialized as a Flickity instance by the
 * global bundle (makeSliders). This script waits for that instance, then:
 *  - selects the matching slide when a thumbnail is clicked
 *  - highlights the active thumbnail as the slideshow rotates
 *  - pauses HTML5 / YouTube / Vimeo videos when their slide is left
 */
(function () {
  function pauseInactiveMedia(slider, activeIndex) {
    slider.querySelectorAll('.media-container').forEach((slide) => {
      if (Number(slide.dataset.index) === activeIndex) return;

      const video = slide.querySelector('video');
      if (video && !video.paused) video.pause();

      const iframe = slide.querySelector('iframe');
      if (iframe && iframe.contentWindow) {
        if (iframe.src.indexOf('youtube.com') !== -1) {
          iframe.contentWindow.postMessage(
            JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
            '*'
          );
        } else if (iframe.src.indexOf('vimeo.com') !== -1) {
          iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
        }
      }
    });
  }

  function bindThumbsCarousel(gallery) {
    const row = gallery.querySelector('[data-gallery-thumbs]');
    const prevBtn = gallery.querySelector('[data-thumbs-prev]');
    const nextBtn = gallery.querySelector('[data-thumbs-next]');
    if (!row || !prevBtn || !nextBtn) return;

    const updateArrows = () => {
      const maxScroll = row.scrollWidth - row.clientWidth - 1;
      prevBtn.disabled = row.scrollLeft <= 0;
      nextBtn.disabled = row.scrollLeft >= maxScroll;
    };

    prevBtn.addEventListener('click', () => {
      row.scrollBy({ left: -row.clientWidth, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', () => {
      row.scrollBy({ left: row.clientWidth, behavior: 'smooth' });
    });
    row.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function bindGallery(gallery, slider, flkty) {
    const thumbs = Array.from(gallery.querySelectorAll('[data-thumb-index]'));
    const row = gallery.querySelector('[data-gallery-thumbs]');

    const syncThumbs = () => {
      let active = null;
      thumbs.forEach((thumb) => {
        const isActive = Number(thumb.dataset.thumbIndex) === flkty.selectedIndex;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) active = thumb;
      });
      // keep the active thumb visible in the strip (centered when possible)
      if (active && row && row.scrollWidth > row.clientWidth) {
        row.scrollTo({
          left: active.offsetLeft - (row.clientWidth - active.clientWidth) / 2,
          behavior: 'smooth',
        });
      }
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        flkty.select(Number(thumb.dataset.thumbIndex));
      });
    });

    flkty.on('select', () => {
      syncThumbs();
      pauseInactiveMedia(slider, flkty.selectedIndex);
    });

    // The slideshow may already have jumped to a variant's image before this
    // binding ran (initial variant selection on load) — sync the highlight now.
    syncThumbs();

    bindThumbsCarousel(gallery);
  }

  function initGallery(gallery) {
    const slider = gallery.querySelector('.bd-slider');
    if (!slider) return;

    let attempts = 0;
    const whenReady = () => {
      const flkty = typeof Flickity !== 'undefined' ? Flickity.data(slider) : null;
      if (flkty) {
        bindGallery(gallery, slider, flkty);
      } else if (attempts++ < 300) {
        requestAnimationFrame(whenReady);
      }
    };
    whenReady();
  }

  const init = () => document.querySelectorAll('[data-product-gallery]').forEach(initGallery);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
